var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavSearches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.01 11H14.21L13.94 10.73C14.92 9.59 15.51 8.12 15.51 6.5C15.51 2.91 12.6 0 9.01 0C5.42 0 2.51 3 2.51 6.5H0L3.84 10.5L8 6.5H4.51C4.51 4 6.53 2 9.01 2C11.49 2 13.51 4.01 13.51 6.5C13.51 8.98 11.49 11 9.01 11C8.36 11 7.75 10.86 7.19 10.62L5.71 12.1C6.68 12.67 7.8 13 9.01 13C10.62 13 12.09 12.41 13.23 11.43L13.5 11.7V12.49L18.51 17.48L20 16L15.01 11Z",
    fill: "#879EBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavSearches);
export default __webpack_public_path__ + "static/media/nav-searches.04f20913d8678d71943e355e21a4ce8b.svg";
export { ForwardRef as ReactComponent };